<template>
    <div class="echartsBox">
        <div ref="ciyun1" id="ciyun1" class="ciyun1"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
require("echarts-wordcloud");
import * as methods from './method.js'
export default {
    //词云
    name: 'template.scope20',
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n
        },
        defaultdata(n) {
            this.DrawEcharts()
        }
    },
    data() {
        return {
            title: '词云图-scope20',
            data: [],
            timer: null,
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
            ],
            defaultdata: [
                { value1: '文本一', value2: 366 },
                { value1: "文本二", value2: 800 },
                { value1: "文本三", value2: 606 },
                { value1: "文本四", value2: 665 },
                { value1: "文本五", value2: 535 },
                { value1: "文本六", value2: 535 },
                { value1: "文本七", value2: 535 },
                { value1: "文本八", value2: 535 },
                { value1: "文本九", value2: 535 },
                { value1: "文本十", value2: 535 },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {}
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    },
    methods: {
        ...methods,
        DrawEcharts() {
            clearInterval(this.timer)
            this.timer = null
            var TmyChart = echarts.init(this.$refs.ciyun1);
            let data = this.defaultdata.map(item => {
                let name = item.value1;

                if (name.length > 4) {
                    name = name.slice(0, 4) + '...';
                }
                return {
                    name: name,
                    value: +item.value2,
                    name1: item.value1    //请勿删除，用于显示tooltip
                }
            })
            // console.log(data,"|scope20|");
            var maxValue = Math.max(...data.map(item => item.value));
            var Toption = {
                tooltip: {
                    // 显示tooltip
                    show: true,
                    // 格式化tooltip内容
                    formatter: function (params) {
                        // return  params.name + '<br>' + params.value;
                        return params.data.name1;
                    }
                },
                series: [{
                    type: 'wordCloud',
                    shape: 'circle',
                    keepAspect: false,
                    left: 'center',
                    top: 'center',
                    width: '100%',
                    height: '100%',
                    right: null,
                    bottom: null,
                    sizeRange: [10, 20],
                    rotationRange: [0, 0],
                    rotationStep: 20,
                    gridSize: 30,
                    drawOutOfBound: false,
                    layoutAnimation: true,
                    textStyle: {
                        color: (item) => {
                            // 根据值计算透明度，实现渐变效果
                            let alpha = item.value / maxValue;
                            return `rgba(255, 255, 255, ${alpha})`;
                        }
                    },
                    emphasis: {
                        textStyle: {
                            textShadowBlur: 3,
                            textShadowColor: '#FFF'
                        }
                    },
                    data: data,
                }]
            }

            TmyChart.on("click", function (e) {
                // console.log(e)
            });

            Toption && TmyChart.setOption(Toption);

            this.timer = setInterval(() => {
                // 每次更新时重新计算颜色
                Toption.series[0].textStyle.color = (item) => {
                    let alpha = item.value / maxValue;
                    return `rgba(255, 255, 255, ${alpha})`;
                };
                TmyChart.setOption(Toption);
            }, 5000);
        },
        getColor() {
            let color = []
            this.data.forEach(element => {
                let alpha = parseFloat(element.value / (+this.data[0].value2).toFixed(2))
                color.push(`rgba(255, 255, 255, ${alpha})`)
            })
            return color
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata
        }
        this.setData()
        this.DrawEcharts()
    },

}
</script>

<style scoped>
.echartsBox {
    width: 435px;
    height: 240px;
    display: flex;
    position: relative;
    padding: 10px 0;
    overflow: hidden;
}
.ciyun1 {
  width: 100%;
  height: 260px;
}

.video {
    width: 330px;
    height: 175px;
    position: absolute;
    top: 26px;
    left: 57px;
    z-index: -1;
}

#ciyun1 {
    
    background-image: url("@/assets/RN/dz.png");
    background-repeat: no-repeat;
    background-size: 100% 90%;
    background-position: center;
}
</style>